import { css } from "@emotion/react";
import { theme } from "@/constants/theme";

export const containerStyles = css({
  position: "relative",
  width: "100%",
  height: "100vh",
  overflow: "hidden",
});

export const slideStyles = (isActive: boolean) =>
  css({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    transition: "opacity 1s ease-in-out",
    opacity: isActive ? 1 : 0,
  });

export const contentWrapperStyles = css({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 10,
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "flex-end",
  [theme.breakpoints.down("sm")]: {
    paddingRight: 0,
  },
});

export const contentStyles = css({
  width: "100%",
  maxWidth: "1440px",
  margin: "0 auto",
  padding: "0 24px",
  display: "flex",
  alignItems: "center",
  height: "100%",
  justifyContent: "flex-end",
});

export const textContainer = css({
  textAlign: "right",
  borderRadius: "12px",
  padding: "32px 40px",
  backgroundColor: "rgba(0, 0, 0, 0.4)",
  backdropFilter: "blur(15px)",
  boxShadow: "0 12px 40px rgba(0, 0, 0, 0.3)",
  border: "1px solid rgba(255, 255, 255, 0.1)",
});

export const headingStyles = css({
  color: "#f8f8f2",
  fontSize: "56px",
  textShadow: "2px 2px 8px rgba(0, 0, 0, 0.8), 0 0 20px rgba(0, 0, 0, 0.1)",
  marginBottom: "16px",
  lineHeight: 1.2,
  fontWeight: 700,
});

export const subheadingStyles = css({
  fontSize: "24px",
  marginBottom: "24px",
  color: "#f5f5f0",
  lineHeight: 1.4,
  textShadow: "1px 1px 4px rgba(0, 0, 0, 0.8), 0 0 15px rgba(0, 0, 0, 0.1)",
  [theme.breakpoints.down("md")]: {
    fontSize: "20px !important",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "18px !important",
  },
});

export const arrowButtonStyles = css({
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 15,
  width: "48px",
  height: "48px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  color: "#fff",
  backgroundColor: "rgba(0,0,0,0.5)",
  transition: "background-color 0.2s ease",
  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.7)",
  },

  ".MuiSvgIcon-root": {
    fontSize: "1.8rem",
  },
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
});

export const arrowLeftStyles = css({
  left: "16px",
});

export const arrowRightStyles = css({
  right: "16px",
});

export const ctaButtonStyles = css({
  fontSize: "16px",
  fontWeight: 500,
  padding: "12px 32px",
  borderRadius: "8px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
  "&:hover": {
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.4)",
    transform: "translateY(-2px)",
  },
  transition: "all 0.3s ease",
});
